import React from 'react'
import { Box, Flex } from 'rebass/styled-components'
import loadable from '@loadable/component'
import Spacer from '../components/general/Spacer'

const Container = ({ options, data }) => {
    const containerContent = []

    if (options.content && options.content.modules && options.content.modules.length) {
        Object.entries(options.content.modules).map(([key, module]) => {
            const RenderedModule = loadable(props => import(`./${module.module}`))
            containerContent.push(<RenderedModule key={`container_${key}`} options={module} data={data} />)
            return true
        })
    }

    return (
        <Flex
            alignItems={options.align || 'auto'} 
            justifyContent={options.justify || 'flex-start'} 
            variant="container"
            maxWidth={options.type === 'fluid' ? '100%' : '1400px'}
            sx={{
                position: 'relative'
            }}
        >
            <Spacer spacing={options.spacing} width={options.width || '100%'} maxWidth={options.maxWidth || '100%' }>      
                <Box width={'100%'}>
                    {containerContent}
                </Box>
                {
                    options.backgroundColor || options.backgroundHeight ? 
                        <Box bg={options.backgroundColor || ''} sx={{
                            position: 'absolute',
                            bottom: '0',
                            left: '0',
                            height: options.backgroundHeight || '100%',
                            width: '100%',
                            zIndex: -1
                        }}></Box>
                    : null
                }
                
            </Spacer>
        </Flex>
    )
}

export default Container
